import { hasEventRsvpDeadlinePassed } from '../../../FrontEndReact/src/Core/Utils/eventRsvp';
import { isEventRecruitingSubstitutes } from '../../../FrontEndReact/src/Core/Utils/eventRecruitment';
import { useEffect, useMemo, useRef, useState } from 'react';
import {
	useGetOneEvent,
	useGetGeneralEventFrontEndClientSettings,
	useSelfAddAsSubstituteCoOrganizer,
	useUpdateParticipationStatus,
	useSelfRegisterAbsenceAsCoOrganizer,
	useCompleteEvent,
} from '../../../FrontEndReact/src/Core/Services/event';
import { formatDate, formatToSimpleTimeString } from '../../../FrontEndReact/src/Core/Utils/dateUtils';

import {
	Event,
	EventActiveModuleKey,
	EventActiveModuleKeys,
	EventStatus,
	GeneralEventFrontEndClientSettings,
	ParticipationStatus,
	UpdateParticipationStatusResult,
} from '../../../FrontEndReact/src/Core/Types/event';
import './OneEvent.scss';
import './OneEvent2col.scss';

import { getBackgroundImageStyle } from '../../../FrontEndReact/src/Core/Services/mediabank';
import { ObjectType } from '../../../FrontEndReact/src/Core/Types/base';
import BizMediabankListUser from '../../../FrontEndReact/src/Core/Components/BizMediabank/BizMediabankListUser';
import BizTabs, { BizTab } from '../../../FrontEndReact/src/Core/Components/Mini/BizTabs';
import { MediabankUploadLocation } from '../../../FrontEndReact/src/Core/Types/mediabank';
import { BizButton } from '../../../FrontEndReact/src/Core/Components/Mini/BizButton';
import Chat from '../../../FrontEndReact/src/Modules/Chat/Chat';
import { hasModuleAccess } from '../../../FrontEndReact/src/Core/Services/access';
import { useGlobalState } from '../../../FrontEndReact/src/Core/Contexts/globalStateContext';
import { AccessTypeRight } from '../../../FrontEndReact/src/Core/Types/access';
import GenericComments from '../../../FrontEndReact/src/Core/Components/GenericComments';
import { GenericCommentObjectType } from '../../../FrontEndReact/src/Core/Types/genericComment';
import BizPhrase from '../../Components/Phrase';
import BizWhiteboard from '../../../FrontEndReact/src/Core/Components/BizWhiteboard/BizWhiteboard';
import { goto, useGetTranslations } from '../../../Js/React/Services/legacy';
import PollList from '../../../FrontEndReact/src/Core/Components/Poll/PollList';
import SpeedQuizList from '../../../FrontEndReact/src/Modules/SpeedQuiz/SpeedQuizList';
import EventActiveModules from '../../../FrontEndReact/src/Admin/Event/EventActiveModules';
import BizIconButton from '../../../FrontEndReact/src/Core/Components/Mini/BizIconButton';
import BizSpeedquiz from '../SpeedQuiz/speedquiz';
import BizTextArea from '../../../FrontEndReact/src/Core/Components/Mini/BizTextArea';
import { useGetUserSetting, useSetUserSetting } from '../../../FrontEndReact/src/Core/Hooks/useUser';
import CheckInForm from '../../../FrontEndReact/src/Core/Components/CheckIn/CheckInForm';
import EventParticipationManage from '../../../FrontEndReact/src/Admin/Event/EventParticipationManage';
import { User } from '../../../FrontEndReact/src/Core/Types/user';
import { getInitials } from '../../../FrontEndReact/src/Core/Services/user';
import { useEventInformationTab } from '../../../FrontEndReact/src/Core/Services/eventInformationTab';
import EventInformationContent from '../../../FrontEndReact/src/Core/Components/Event/EventInformationContent';

type OneEventProps = {
	eventId: number;
	evnt?: Event;
	tab?: string;
};

const translationKeys = [
	'EVENT.TABS.INTRO',
	'EVENT.TABS.CHECKIN',
	'EVENT.TABS.QUIZ',
	'EVENT.TABS.WHITEBOARD',
	'EVENT.TABS.POLLS',
	'EVENT.TABS.FILES',
	'EVENT.TABS.COMMENTS',
	'EVENT.TABS.PARTICIPANTS',
	'EVENT.SETTINGS_MODAL_TITLE',
	'EVENT.UPCOMING_EVENT_TITLE',
	'EVENT.UPCOMING_EVENT_PREFIX',
	'EVENT.UPCOMING_EVENT_SUFFIX',
	'EVENT.CONTACTS',
	'EVENT.PARTICIPANTS',
	'EVENT.PARTICIPANTS_OF',
	'EVENT.PARTICIPANTS_SLOTS',
	'EVENT.NOT_FOUND_OR_NO_ACCESS',
];

const participationTranslationKeys = [
	'EVENT.BUTTON.SIGN_UP',
	'EVENT.BUTTON.ATTENDING',
	'EVENT.BUTTON.CONFIRMED_ATTENDED',
	'EVENT.BUTTON.WAITLISTED',
	'EVENT.BUTTON.UNREGISTER',
	'EVENT.CONFIRM_UNREGISTER',
	'EVENT.BUTTON.ADD_SELF_AS_SUBSTITUTE_COORGANIZER',
	'EVENT.BUTTON.COORGANIZER_REGISTER_ABSENCE',
	'EVENT.BUTTON.COMPLETE_EVENT',
	'EVENT.UNREGISTER_REASON_MODAL_TITLE',
	'EVENT.UNREGISTER_REASON_OPTIONS',
	'EVENT.UNREGISTER_REASON_OTHER',
	'EVENT.UNREGISTER_REASON_PLACEHOLDER',
	'EVENT.WAITLISTED_MESSAGE',
	'EVENT.FOOD_PREF.LABEL',
	'EVENT.FOOD_PREF.NO_PREF_CHECKBOX',
	'EVENT.FOOD_PREF.PLACEHOLDER',
	'EVENT.SUBSTITUTE_COORGANIZER_HELP_TEXT',
	'EVENT.SUBSTITUTE_COORGANIZER_SLOT_TAKEN',
	'EVENT.COORGANIZER_REGISTER_ABSENCE_HELP_TEXT',
	'EVENT.COORGANIZER_ABSENCE_REASON_MODAL_TITLE',
	'EVENT.COORGANIZER_ABSENCE_REASON_OPTIONS',
	'EVENT.COORGANIZER_ABSENCE_REASON_OTHER',
	'EVENT.COORGANIZER_ABSENCE_REASON_PLACEHOLDER',
	'EVENT.COMPLETED',
	'EVENT.COORGANIZER_ABSENCE_REGISTERED',
];

const OneEvent2col = ({ eventId, evnt: pEvent, tab: pTab }: OneEventProps) => {
	const fEvent = useGetOneEvent(eventId);
	const {
		state: { user },
		showModal,
	} = useGlobalState();
	const generalSettings = useGetGeneralEventFrontEndClientSettings();
	const [selectedTab, setSelectedTab] = useState(pTab || 'intro');

	const uploadRef = useRef<(() => void) | null>(null);
	const translations = useGetTranslations(translationKeys);

	//const triggerFileUpload = () => {
	//	if (uploadRef.current) {
	//		uploadRef.current();
	//	} else {
	//		console.log('No upload handler available');
	//	}
	//};

	const evnt = pEvent ?? fEvent;
	const canReadInformation = hasModuleAccess(user, 'EVENT', AccessTypeRight.EditLimited);
	const informationQuery = useEventInformationTab(eventId, false, canReadInformation && !!evnt);
	const information = canReadInformation && informationQuery.statusState !== 'ERROR' ? informationQuery.data : null;

	const informationPending = canReadInformation && !informationQuery.data && !informationQuery.error;

	const tabs = useMemo(() => {
		if (!evnt || !translations) return [] as BizTab[];

		const activeModules = evnt.ActiveModules || [];
		const isModuleActive = (moduleKey: EventActiveModuleKey) => activeModules.includes(moduleKey);

		return [
			{
				key: 'intro',
				title: translations['EVENT.TABS.INTRO'] || 'Intro',
				icon: 'far fa-info-circle',
				visible: isModuleActive(EventActiveModuleKeys.Intro),
			},
			{
				key: 'information',
				title: information?.title || '',
				icon: 'far fa-info-circle',
				visible: !!information?.enabled,
			},
			{
				key: 'checkin',
				title: translations['EVENT.TABS.CHECKIN'] || 'Check-in',
				icon: 'fa-regular fa-clipboard-question',
				visible: (window.portalSettings['IsCheckInEnabled'] && isModuleActive(EventActiveModuleKeys.CheckIn)) || false,
			},
			{
				key: 'quiz',
				title: translations['EVENT.TABS.QUIZ'] || 'Quiz',
				icon: 'far fa-chart-bar',
				visible: (window.portalSettings['IsSpeedquizEnabled'] && isModuleActive(EventActiveModuleKeys.Quiz)) || false,
			},
			{
				key: 'whiteboard',
				title: translations['EVENT.TABS.WHITEBOARD'] || 'Whiteboard',
				icon: 'far fa-palette',
				visible:
					(window.portalSettings['IsWhiteboardEnabled'] && isModuleActive(EventActiveModuleKeys.Whiteboard)) || false,
			},
			{
				key: 'polls',
				title: translations['EVENT.TABS.POLLS'] || 'Polls',
				icon: 'far fa-poll-people',
				visible: (window.portalSettings['IsPollsEnabled'] && isModuleActive(EventActiveModuleKeys.Polls)) || false,
			},
			{
				key: 'files',
				title: translations['EVENT.TABS.FILES'] || 'Files',
				icon: 'far fa-file',
				visible: (window.portalSettings['IsMediabankEnabled'] && isModuleActive(EventActiveModuleKeys.Files)) || false,
			},
			{
				key: 'comments',
				title: translations['EVENT.TABS.COMMENTS'] || 'Comments',
				icon: 'far fa-comments',
				visible: (window.portalSettings['IsCommentsEnabled'] && isModuleActive(EventActiveModuleKeys.Comments)) || false,
			},
			{
				key: 'participation',
				title: translations['EVENT.TABS.PARTICIPANTS'] || 'Participants',
				icon: 'far fa-users',
				visible: evnt.IsAllowedToHandleEvent,
			},
		];
	}, [evnt, translations, information]);

	useEffect(() => {
		if (tabs.length === 0) return;

		const visibleTabs = tabs.filter((tab) => tab.visible !== false);
		if (visibleTabs.length === 0) return;

		setSelectedTab((currentSelectedTab) => {
			if (currentSelectedTab === 'information' && informationPending) return currentSelectedTab;
			if (visibleTabs.some((tab) => tab.key === currentSelectedTab)) {
				return currentSelectedTab;
			}

			return (visibleTabs.find((tab) => tab.key === 'intro') ?? visibleTabs[0]).key;
		});
	}, [tabs, informationPending]);

	//console.log('evnt', evnt);

	if (!evnt) {
		if (fEvent === null) {
			return (
				<div className='one-event-wrapper col-2'>
					<div className='event-info layout-card'>
						<div className='note note-warning'>
							{translations?.['EVENT.NOT_FOUND_OR_NO_ACCESS'] ||
								'The event could not be found or you do not have access to it.'}
						</div>
					</div>
				</div>
			);
		}

		return null;
	}

	const rsvpPassed = hasEventRsvpDeadlinePassed(evnt.RSVPDateTimeUtc);
	//console.log('rsvp passed', rsvpPassed);

	const hasStarted = new Date(evnt.StartDateTimeUtc) < new Date();

	const isCancelled = evnt.Status === EventStatus.Cancelled;

	const allowedChat = hasModuleAccess(user, 'CHAT', AccessTypeRight.Read);
	const hasWriteAccess = hasModuleAccess(user, 'EVENT', AccessTypeRight.Write);

	const organizerHasInfo = !!evnt.Organizer?.Name || !!evnt.Organizer?.Email;
	const isMultiDayEvent =
		evnt.StartDateTimeUtc.getFullYear() !== evnt.EndDateTimeUtc.getFullYear() ||
		evnt.StartDateTimeUtc.getMonth() !== evnt.EndDateTimeUtc.getMonth() ||
		evnt.StartDateTimeUtc.getDate() !== evnt.EndDateTimeUtc.getDate();

	const formatDescription = (description: string) => {
		return description?.replaceAll('\n', '<br>');
	};

	const handleDirectMessageClick = (userId?: number) => (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.preventDefault();

		if (!userId) {
			return;
		}

		goto('base.modules.chatdirectmessage', { dmToUserId: userId });
	};

	return (
		<>
			<div className={`one-event-wrapper col-2 ${rsvpPassed ? 'rsvp-passed' : ''}`}>
				<div className='event-info layout-card'>
					<div className='event-header'>
						<h2>{evnt.Name}</h2>
						{hasWriteAccess && (
							<BizIconButton
								icon='SETTINGS'
								noBackground
								legacy={false}
								onClick={() =>
									showModal(
										<EventActiveModules eventId={evnt.Id} />,
										translations['EVENT.SETTINGS_MODAL_TITLE'] || 'Event module settings'
									)
								}
							/>
						)}
					</div>
					<div className='event-top' style={getBackgroundImageStyle(evnt.MbfObject, evnt.ImageUrl, 'sm')}></div>
					<div className='event-props'>
						{isMultiDayEvent ? (
							<div className='event-time event-end-time'>
								<span className='event-info-item'>
									<i className='fa-light fa-calendar-days'></i>
									<span>
										<time dateTime={evnt.StartDateTimeUtc.toString()}>
											{formatDate(evnt.StartDateTimeUtc, 'dd MMM')}{' '}
											{formatToSimpleTimeString(evnt.StartDateTimeUtc)}
										</time>
										<span aria-hidden='true'> – </span>
										<span className='visually-hidden'> {translations['EVENT.TO_DATE'] || 'to'} </span>
										<time dateTime={evnt.EndDateTimeUtc.toString()}>
											{formatDate(evnt.EndDateTimeUtc, 'dd MMM')}{' '}
											{formatToSimpleTimeString(evnt.EndDateTimeUtc)}
										</time>
									</span>
								</span>
							</div>
						) : (
							<time dateTime={evnt.StartDateTimeUtc.toString()}>
								<div className='event-prop-multi-wrapper'>
									<div className='event-date'>
										<span className='event-info-item'>
											<i className='fa-light fa-calendar-days' aria-hidden='true'></i>
											<span>{formatDate(evnt.StartDateTimeUtc, 'dd MMMM')}</span>
										</span>
									</div>
									<div className='event-time'>
										<span className='event-info-item'>
											<i className='fa-light fa-clock' aria-hidden='true'></i>
											<span>
												{formatToSimpleTimeString(evnt.StartDateTimeUtc)}
												<span aria-hidden='true'> - </span>
												<span className='visually-hidden'> {translations['EVENT.TO_DATE'] || 'to'} </span>
												{formatToSimpleTimeString(evnt.EndDateTimeUtc)}
											</span>
										</span>
									</div>
								</div>
							</time>
						)}
						<div className='event-prop-multi-wrapper'>
							<div className='event-location'>
								<span className='event-info-item'>
									<i className='fa-regular fa-location-dot' aria-hidden='true'></i>
									<span>{evnt.Location}</span>
								</span>
							</div>
							<div className='event-participants'>
								<span className='event-info-item'>
									<i className='fa-regular fa-user' aria-hidden='true'></i>
									<span>
										<span className='visually-hidden'>
											{translations['EVENT.PARTICIPANTS'] || 'Participants'}:{' '}
										</span>
										{evnt.ParticipantCount}
										{evnt.MaxParticipants < 999 && (
											<>
												<span aria-hidden='true'> / </span>
												<span className='visually-hidden'>
													{' '}
													{translations['EVENT.PARTICIPANTS_OF'] || 'of'}{' '}
												</span>
												{evnt.MaxParticipants}
												<span className='visually-hidden'>
													{' '}
													{translations['EVENT.PARTICIPANTS_SLOTS'] || 'slots'}
												</span>
											</>
										)}
									</span>
								</span>
							</div>
						</div>
						<div className='event-contact-info'>
							<span className='event-contact-header'>
								<strong>{translations['EVENT.CONTACTS'] || 'Contacts'}</strong>
							</span>

							{evnt.Organizer && organizerHasInfo && (
								<div className='event-organizer'>
									<address>
										<span className='circle'>{getInitials(evnt.Organizer?.Name)}</span>
										<span className='contact-name'>{evnt.Organizer?.Name}</span>
										{window.portalSettings['IsChatEnabled'] && (
											<a href='#' onClick={handleDirectMessageClick(evnt.Organizer?.Id)} className='circle'>
												<i className='far fa-comment'></i>
											</a>
										)}
										<a className='circle' href={`mailto:${evnt.Organizer?.Email}`}>
											<span className='visually-hidden'>{translations['EVENT.EMAIL'] || 'Email'}: </span>
											<i className='fa-light fa-envelope'></i>
										</a>
									</address>
								</div>
							)}
							{evnt.CoOrganizers && (
								<>
									{evnt.CoOrganizers.filter((co) => !co.IsAbsent).map((coOrganizer) => (
										<div className='event-organizer' key={coOrganizer.Id}>
											<address>
												<span className='circle'>{getInitials(coOrganizer.Name)}</span>
												<span className='contact-name'>{coOrganizer.Name}</span>
												{window.portalSettings['IsChatEnabled'] && (
													<a
														href='#'
														onClick={handleDirectMessageClick(coOrganizer.Id)}
														className='circle'
													>
														<i className='far fa-comment'></i>
													</a>
												)}
												<a className='circle' href={`mailto:${coOrganizer.Email}`}>
													<span className='visually-hidden'>
														{translations['EVENT.EMAIL'] || 'Email'}:{' '}
													</span>
													<i className='fa-light fa-envelope'></i>
												</a>
											</address>
										</div>
									))}
								</>
							)}
						</div>
					</div>
					{evnt.ShortDescription && (
						<p
							className='event-description'
							dangerouslySetInnerHTML={{
								__html: formatDescription(evnt.ShortDescription || ''),
							}}
						></p>
					)}
					{evnt.IsAllowedToHandleEvent && evnt.InternalDescription && (
						<p className='event-description' style={{ whiteSpace: 'pre-line' }}>
							{evnt.InternalDescription}
						</p>
					)}

					{!!user && <EventParticipation evnt={evnt} user={user} generalSettings={generalSettings} />}

					{/* cant use external with participants */}
					{/* evnt.IsExternal &&  */}
					{evnt.ExternalUrl && hasStarted && !isCancelled && (
						<div className='event-external-link'>
							<a href={evnt.ExternalUrl} target='_blank' rel='noreferrer'>
								<BizPhrase phraseKey='EVENT.BUTTON.OPEN_EXT_EVENT'></BizPhrase>
							</a>
						</div>
					)}
				</div>

				<div className='event-content layout-card'>
					{!hasStarted && !evnt.IsAllowedToHandleEvent && (
						<div className='tab-content upcoming-event-info'>
							<h2>{translations['EVENT.UPCOMING_EVENT_TITLE'] || 'Upcoming event'}</h2>
							<p>
								{translations['EVENT.UPCOMING_EVENT_PREFIX'] || 'This session is scheduled for'}{' '}
								{formatDate(evnt.StartDateTimeUtc, 'dd MMMM')} {formatToSimpleTimeString(evnt.StartDateTimeUtc)}.{' '}
								{translations['EVENT.UPCOMING_EVENT_SUFFIX'] || 'You’ll be notified before it begins.'}
							</p>
							<CheckInForm objectType={ObjectType.Event} objectId={evnt.Id} hideTitle={true} hideDisabled={true} />
						</div>
					)}
					{(hasStarted || evnt.IsAllowedToHandleEvent) && (
						<>
							<div className='layout-card-header'>
								<BizTabs
									tabs={tabs}
									selectedTabKey={selectedTab}
									onClick={(key) => setSelectedTab(key)}
								></BizTabs>
							</div>

							<div className='tab-content'>
								{selectedTab === 'intro' && (
									<div>
										{evnt.Description && (
											<p
												className='event-description-full'
												dangerouslySetInnerHTML={{
													__html: evnt.Description,
												}}
											></p>
										)}
									</div>
								)}
								{selectedTab === 'information' && information?.enabled && (
									<EventInformationContent html={information.html} />
								)}
								{selectedTab === 'checkin' && (
									<div>
										<CheckInForm objectType={ObjectType.Event} objectId={evnt.Id} hideTitle={true} />
									</div>
								)}
								{selectedTab === 'quiz' && (
									<div>
										<SpeedQuizList
											objectType={ObjectType.Event}
											objectId={evnt.Id}
											getLegacyQuizComponent={(quizId: number, customBackFn?: () => void) => (
												<BizSpeedquiz
													quizId={quizId}
													fromOneQuiz={true}
													objectType={ObjectType.Event}
													objectId={evnt.Id}
													customBackFn={customBackFn}
												/>
											)}
										/>
									</div>
								)}
								{selectedTab === 'whiteboard' && (
									<BizWhiteboard objectType={ObjectType.Event} objectId={evnt.Id} />
								)}
								{selectedTab === 'polls' && (
									<div>
										<PollList
											objectType={ObjectType.Event}
											objectId={evnt.Id}
											readonly={!evnt.IsAllowedToHandleEvent && !hasStarted}
										/>
									</div>
								)}
								{selectedTab === 'files' && (
									<div>
										{/* {evnt.IsAllowedToHandleEvent && (
									<BizButton onClick={triggerFileUpload} text='Upload' isLead={true}></BizButton>
								)} */}

										<BizMediabankListUser
											triggerUpload={(handler) => {
												uploadRef.current = handler;
											}}
											showUploadButton={true}
											params={{
												ObjectIds: [evnt.Id],
												ObjectTypes: [ObjectType.Event],
											}}
											uploadSettings={
												evnt.IsAllowedToHandleEvent
													? {
															uploadLocation: MediabankUploadLocation.EventAdmin,
															settings: {
																linkToObject: {
																	ObjectId: evnt.Id,
																	ObjectType: ObjectType.Event,
																},
																isPrivate: false,
																isInvisible: false,
																skipResize: false,
															},
														}
													: undefined
											}
											showUnlink={evnt.IsAllowedToHandleEvent}
											listModes={['LIST']}
											showDownload={true}
											downloadOnFileClick={true}
										/>
									</div>
								)}
								{selectedTab === 'comments' && (
									<div>
										<GenericComments
											objectType={GenericCommentObjectType.event}
											objectId={evnt.Id}
											isAdmin={evnt.IsAllowedToHandleEvent}
										/>
									</div>
								)}
								{selectedTab === 'participation' && evnt.IsAllowedToHandleEvent && (
									<div>
										<EventParticipationManage eventId={evnt.Id} groupByOrganizer={true} />
									</div>
								)}
							</div>
						</>
					)}
				</div>
			</div>
			{(hasStarted || evnt.IsAllowedToHandleEvent) &&
				allowedChat &&
				evnt.ActiveModules &&
				evnt.ActiveModules.includes(EventActiveModuleKeys.Chat) && (
					<div className='one-event-wrapper-secondary'>
						<div className='event-chat layout-card'>
							{/* 
							How to only show it if there are chats for event? 
							It might become messy with permissions to fetch it together with the event. 
							Another solution is for the Chat component to hide itself if no rooms are available.
							But then the surrounding wrapper is still there...
						*/}
							<Chat
								objectType={generalSettings?.ShowChatOnOneEventWithoutObjectLink ? undefined : ObjectType.Event}
								objectId={generalSettings?.ShowChatOnOneEventWithoutObjectLink ? undefined : evnt.Id}
								showAllUsers={generalSettings?.ShowChatOnOneEventWithoutObjectLink ? false : true}
								scrollToChatOnMobile={true}
							/>
						</div>
					</div>
				)}
		</>
	);
};

export default OneEvent2col;

type EventParticipationProps = {
	evnt: Event;
	user: User;
	generalSettings?: GeneralEventFrontEndClientSettings;
};

const EventParticipation = ({ evnt, user, generalSettings }: EventParticipationProps) => {
	const { showModal } = useGlobalState();
	const { updateParticipationStatus, statusState, updateParticipationStatusResult } = useUpdateParticipationStatus(
		undefined,
		true
	);
	const {
		selfAddAsSubstituteCoOrganizer,
		statusState: selfAddStatusState,
		errorType: selfAddErrorType,
	} = useSelfAddAsSubstituteCoOrganizer();
	const { selfRegisterAbsenceAsCoOrganizer, statusState: selfRegisterStatusState } = useSelfRegisterAbsenceAsCoOrganizer();
	const { completeEvent, statusState: completeEventStatusState } = useCompleteEvent();

	useEffect(() => {
		if (updateParticipationStatusResult === UpdateParticipationStatusResult.UserWaitlisted) {
			alert(
				translations['EVENT.WAITLISTED_MESSAGE'] ||
					'The event is full, you have been added to the waitlist. You will be notified if a spot opens up.'
			);
		}
	}, [updateParticipationStatusResult]);

	const { setSetting } = useSetUserSetting();
	const { getSetting: getNoFoodPrefSetting, settingValue: noFoodPrefSettingValue } = useGetUserSetting();
	const { getSetting: getFoodPrefFreeTextSetting, settingValue: foodPrefFreeTextSettingValue } = useGetUserSetting();

	const [blnHaveNoFoodPref, setBlnHaveNoFoodPref] = useState(false);
	const [strFoodPrefFreeText, setStrFoodPrefFreeText] = useState('');

	const translations = useGetTranslations(participationTranslationKeys);
	const unregisterReasonOptions = useMemo(() => {
		const rawValue = translations['EVENT.UNREGISTER_REASON_OPTIONS'];
		if (!rawValue) return [] as string[];

		return rawValue
			.split('|')
			.map((value) => value.trim())
			.filter(Boolean);
	}, [translations]);
	const unregisterReasonOtherLabel = translations['EVENT.UNREGISTER_REASON_OTHER']?.trim() || '';
	const shouldUseUnregisterReasonModal = unregisterReasonOptions.length > 0 || unregisterReasonOtherLabel.length > 0;

	// Each co-organizer absence option is defined in the translation as `type::reason`,
	// where `type` is the dynamic identifier the backend maps via settings and `reason`
	// is the text shown to the user. The `::` subdivider separates the two parts. Options
	// without a subdivider are treated as reason-only (no absence type).
	const coOrganizerAbsenceReasonOptions = useMemo(() => {
		const rawValue = translations['EVENT.COORGANIZER_ABSENCE_REASON_OPTIONS'];
		if (!rawValue) return [] as UnregisterReasonOption[];

		return rawValue
			.split('|')
			.map((value) => {
				const dividerIndex = value.indexOf('::');
				if (dividerIndex === -1) {
					return { label: value.trim(), type: undefined };
				}

				return {
					type: value.slice(0, dividerIndex).trim(),
					label: value.slice(dividerIndex + 2).trim(),
				};
			})
			.filter((option) => option.label.length > 0);
	}, [translations]);
	const coOrganizerAbsenceReasonOtherLabel = translations['EVENT.COORGANIZER_ABSENCE_REASON_OTHER']?.trim() || '';
	const shouldUseCoOrganizerAbsenceReasonModal =
		coOrganizerAbsenceReasonOptions.length > 0 || coOrganizerAbsenceReasonOtherLabel.length > 0;
	//console.log(translations);

	const rsvpPassed = hasEventRsvpDeadlinePassed(evnt.RSVPDateTimeUtc);
	const hasStarted = new Date(evnt.StartDateTimeUtc) <= new Date();
	const isCancelled = evnt.Status === EventStatus.Cancelled;
	const isCompleted = evnt.Status === EventStatus.Completed;
	const blockParticipationStatusChange = evnt.BlockParticipationStatusChange === true;
	const canShowSignUpButton =
		(evnt.ParticipantCount < evnt.MaxParticipants || evnt.IsWaitlistEnabled) &&
		(evnt.UserStatus === ParticipationStatus.None || evnt.UserStatus === ParticipationStatus.NotAttending);
	const requireFoodPreferences = evnt.AskForFoodPreferences === true;
	const hasFoodPreferenceChoice = blnHaveNoFoodPref || strFoodPrefFreeText.trim().length > 0;
	const signUpDisabled = (requireFoodPreferences && !hasFoodPreferenceChoice) || blockParticipationStatusChange;
	const hasNotReplied = evnt.UserStatus === ParticipationStatus.None || evnt.UserStatus === ParticipationStatus.Invited;

	//we dont need to show the rsvp passed message if the user has already replied or is allowed to handle the event (e.g. organizer), or if the event is cancelled
	const showRsvpPassedMessage = rsvpPassed && hasNotReplied && !evnt.IsAllowedToHandleEvent && !isCancelled;
	const isCoOrganizer = evnt.CoOrganizers?.some((co) => co.Id === user?.Id);
	const isAbsentCoOrganizer = evnt.CoOrganizers?.some((co) => co.Id === user?.Id && co.IsAbsent);
	const isOrganizer = evnt.Organizer?.Id === user?.Id;
	const canSelfAddAsSubstitute =
		!hasStarted && isEventRecruitingSubstitutes(evnt, generalSettings) && !isCoOrganizer && !isOrganizer;

	useEffect(() => {
		if (!requireFoodPreferences) return;

		getNoFoodPrefSetting('blnHaveNoFoodPref');
		getFoodPrefFreeTextSetting('strFoodPrefFreeText');
	}, [requireFoodPreferences]);

	useEffect(() => {
		if (!requireFoodPreferences) return;
		if (noFoodPrefSettingValue === undefined || noFoodPrefSettingValue === null) return;

		const normalized = `${noFoodPrefSettingValue}`.trim().toLowerCase();
		setBlnHaveNoFoodPref(normalized === '1' || normalized === 'true' || normalized === 'yes');
	}, [noFoodPrefSettingValue, requireFoodPreferences]);

	useEffect(() => {
		if (!requireFoodPreferences) return;
		if (foodPrefFreeTextSettingValue === undefined || foodPrefFreeTextSettingValue === null) return;
		setStrFoodPrefFreeText(foodPrefFreeTextSettingValue);
	}, [foodPrefFreeTextSettingValue, requireFoodPreferences]);

	const onSignUp = () => {
		if (signUpDisabled) return;

		if (requireFoodPreferences) {
			setSetting('blnHaveNoFoodPref', blnHaveNoFoodPref ? '1' : '0');
			setSetting('strFoodPrefFreeText', strFoodPrefFreeText);
		}
		updateParticipationStatus(evnt.Id, ParticipationStatus.Attending);
	};

	const onNoFoodPrefChange = (checked: boolean) => {
		setBlnHaveNoFoodPref(checked);
		if (!requireFoodPreferences) return;
		setSetting('blnHaveNoFoodPref', checked ? '1' : '0');
	};

	const onFoodPrefBlur = () => {
		if (!requireFoodPreferences) return;
		setSetting('strFoodPrefFreeText', strFoodPrefFreeText);
	};

	const unregisterFromEvent = (eventId: number) => {
		if (!shouldUseUnregisterReasonModal) {
			window.confirm(translations['EVENT.CONFIRM_UNREGISTER'] || 'Are you sure you want to unregister from this event?') &&
				updateParticipationStatus(eventId, ParticipationStatus.NotAttending);
			return;
		}

		showModal(
			<UnregisterReasonModal
				options={unregisterReasonOptions}
				otherReasonLabel={unregisterReasonOtherLabel}
				otherReasonPlaceholder={
					translations['EVENT.UNREGISTER_REASON_PLACEHOLDER'] || 'Tell us why you can no longer attend...'
				}
				onSubmit={(comment) => updateParticipationStatus(eventId, ParticipationStatus.NotAttending, comment)}
				submitButtonText={translations['EVENT.BUTTON.UNREGISTER'] || 'Unregister'}
				isSubmitting={statusState === 'LOADING'}
			/>,
			translations['EVENT.UNREGISTER_REASON_MODAL_TITLE'] || 'Why can you not attend?'
		);
	};

	const registerAbsenceAsCoOrganizer = (eventId: number) => {
		if (!shouldUseCoOrganizerAbsenceReasonModal) {
			selfRegisterAbsenceAsCoOrganizer(eventId, '', '');
			return;
		}

		showModal(
			<UnregisterReasonModal
				options={coOrganizerAbsenceReasonOptions}
				otherReasonLabel={coOrganizerAbsenceReasonOtherLabel}
				otherReasonPlaceholder={
					translations['EVENT.COORGANIZER_ABSENCE_REASON_PLACEHOLDER'] || 'Tell us why you can no longer attend...'
				}
				onSubmit={(comment, absenceType) => selfRegisterAbsenceAsCoOrganizer(eventId, comment, absenceType ?? '')}
				submitButtonText={
					translations['EVENT.BUTTON.COORGANIZER_REGISTER_ABSENCE'] || 'Register my absence as co-organizer'
				}
				isSubmitting={selfRegisterStatusState === 'LOADING'}
			/>,
			translations['EVENT.COORGANIZER_ABSENCE_REASON_MODAL_TITLE'] || 'Why can you not attend?'
		);
	};

	return (
		<div className='event-participation attending-buttons'>
			{canSelfAddAsSubstitute && (
				<div className='event-self-add-substitute'>
					<div className='note note-warning'>
						{translations['EVENT.SUBSTITUTE_COORGANIZER_HELP_TEXT'] || 'A co-organizer is missing for this event.'}
					</div>
					<BizButton
						text={
							translations['EVENT.BUTTON.ADD_SELF_AS_SUBSTITUTE_COORGANIZER'] || 'Add me as substitute co-organizer'
						}
						onClick={() => selfAddAsSubstituteCoOrganizer(evnt.Id)}
						className='biz-btn biz-primary'
						state={selfAddStatusState}
						legacy={true}
					/>
					{selfAddErrorType === 'CONFLICT' && (
						<div className='note note-danger event-self-add-substitute-taken'>
							{translations['EVENT.SUBSTITUTE_COORGANIZER_SLOT_TAKEN'] ||
								'Someone else has already taken the co-organizer slot. A substitute is no longer needed.'}
						</div>
					)}
				</div>
			)}
			{!hasStarted && isCoOrganizer && !isAbsentCoOrganizer && generalSettings?.AllowCoOrganizersToRegisterAbsence && (
				<div className='event-coorganizer-register-absence'>
					<span>{translations['EVENT.COORGANIZER_REGISTER_ABSENCE_HELP_TEXT']}</span>
					<BizButton
						text={translations['EVENT.BUTTON.COORGANIZER_REGISTER_ABSENCE'] || 'Register my absence as co-organizer'}
						onClick={() => registerAbsenceAsCoOrganizer(evnt.Id)}
						className='biz-btn biz-primary event-coorganizer-register-absence-button'
						state={selfRegisterStatusState}
						legacy={true}
					/>
				</div>
			)}
			{evnt.IsAllowedToHandleEvent && hasStarted && !isAbsentCoOrganizer && (
				<div className='event-complete-event'>
					{!isCompleted && (
						<BizButton
							text={translations['EVENT.BUTTON.COMPLETE_EVENT'] || 'Complete Event'}
							onClick={() => completeEvent(evnt.Id)}
							className='biz-btn biz-primary'
							state={completeEventStatusState}
							legacy={true}
						/>
					)}
					{isCompleted && (
						<BizButton
							text={translations['EVENT.COMPLETED'] || 'Event Completed'}
							onClick={() => {}}
							className='biz-btn biz-primary'
							disabled={true}
							legacy={true}
						/>
					)}
				</div>
			)}
			{isAbsentCoOrganizer && (
				<div className='event-coorganizer-absence-registered'>
					<BizButton
						text={
							translations['EVENT.COORGANIZER_ABSENCE_REGISTERED'] ||
							'You have registered your absence as co-organizer for this event.'
						}
						onClick={() => {}}
						className='biz-btn biz-primary'
						disabled={true}
						legacy={true}
					/>
				</div>
			)}
			{showRsvpPassedMessage && (
				<span className='rsvp-passed-text'>
					<BizPhrase phraseKey='EVENT.RSVP_PASSED'></BizPhrase>
				</span>
			)}
			{!rsvpPassed && !isCancelled && !evnt.IsAllowedToHandleEvent && (
				<>
					{canShowSignUpButton && requireFoodPreferences && (
						<div className='event-food-pref-wrapper'>
							<label className='event-food-pref-checkbox'>
								<input
									type='checkbox'
									checked={blnHaveNoFoodPref}
									onChange={(e) => onNoFoodPrefChange(e.target.checked)}
								/>
								<span>
									{translations['EVENT.FOOD_PREF.NO_PREF_CHECKBOX'] || `I don't have any food preferences`}
								</span>
							</label>
							{!blnHaveNoFoodPref && (
								<div className='event-food-pref-textarea'>
									<span className='event-food-pref-label'>
										{translations['EVENT.FOOD_PREF.LABEL'] || 'Food preferences'}
									</span>
									<BizTextArea
										value={strFoodPrefFreeText}
										onChange={(e) => setStrFoodPrefFreeText(e.target.value)}
										onBlur={onFoodPrefBlur}
										placeholder={
											translations['EVENT.FOOD_PREF.PLACEHOLDER'] || 'Write your food preferences...'
										}
										rows={3}
										className='form-control'
									/>
								</div>
							)}
						</div>
					)}
					{canShowSignUpButton && (
						<BizButton
							text={translations['EVENT.BUTTON.SIGN_UP'] || 'Sign up'}
							onClick={onSignUp}
							disabled={signUpDisabled}
							className={`biz-btn attending sign-up`}
							state={statusState}
							legacy={true}
						/>
					)}
					{evnt.UserStatus === ParticipationStatus.Attending && (
						<>
							<BizButton
								text={translations['EVENT.BUTTON.ATTENDING'] || 'Attending'}
								disabled={true}
								onClick={() => {}}
								className={`biz-btn attending active`}
								legacy={true}
							/>
						</>
					)}
					{evnt.UserStatus === ParticipationStatus.ConfirmedAttended && (
						<>
							<BizButton
								text={translations['EVENT.BUTTON.CONFIRMED_ATTENDED'] || 'Attended'}
								disabled={true}
								onClick={() => {}}
								className={`biz-btn attending active`}
								legacy={true}
							/>
						</>
					)}
					{evnt.UserStatus === ParticipationStatus.Waitlisted && (
						<>
							<BizButton
								text={translations['EVENT.BUTTON.WAITLISTED'] || 'Waitlisted'}
								disabled={true}
								onClick={() => {}}
								className={`biz-btn waitlisted active`}
								legacy={true}
							/>
						</>
					)}
					{(evnt.UserStatus === ParticipationStatus.Attending ||
						evnt.UserStatus === ParticipationStatus.Waitlisted ||
						evnt.UserStatus === ParticipationStatus.ConfirmedAttended) &&
						!blockParticipationStatusChange && (
							<>
								<BizButton
									text={translations['EVENT.BUTTON.UNREGISTER'] || 'Unregister'}
									onClick={() => unregisterFromEvent(evnt.Id)}
									className={`biz-btn event-unregister`}
									legacy={true}
								/>
							</>
						)}
				</>
			)}
		</div>
	);
};

type UnregisterReasonOption = {
	label: string;
	type?: string;
};

type UnregisterReasonModalProps = {
	options: (string | UnregisterReasonOption)[];
	otherReasonLabel: string;
	otherReasonPlaceholder: string;
	onSubmit: (comment: string, type?: string) => void;
	submitButtonText: string;
	isSubmitting: boolean;
};

const UnregisterReasonModal = ({
	options,
	otherReasonLabel,
	otherReasonPlaceholder,
	onSubmit,
	submitButtonText,
	isSubmitting,
}: UnregisterReasonModalProps) => {
	const { hideModal } = useGlobalState();
	const [selectedReason, setSelectedReason] = useState<string | null>(null);
	const [customReason, setCustomReason] = useState('');
	const isOtherSelected = selectedReason === '__other__';
	const canSubmitCustomReason = customReason.trim().length > 0 && !isSubmitting;

	const normalizedOptions = options.map((option) => (typeof option === 'string' ? { label: option, type: undefined } : option));

	const submitAndClose = (comment: string, type?: string) => {
		onSubmit(comment, type);
		hideModal();
	};

	return (
		<div className='event-unregister-reason-modal'>
			<div className='event-unregister-reason-options'>
				{normalizedOptions.map((option) => (
					<button
						key={option.label}
						type='button'
						className='event-unregister-reason-option'
						onClick={() => submitAndClose(option.label, option.type)}
						disabled={isSubmitting}
					>
						{option.label}
					</button>
				))}
				{otherReasonLabel && (
					<button
						type='button'
						className={`event-unregister-reason-option ${isOtherSelected ? 'is-active' : ''}`}
						onClick={() => setSelectedReason('__other__')}
						disabled={isSubmitting}
					>
						{otherReasonLabel}
					</button>
				)}
			</div>
			{isOtherSelected && (
				<div className='event-unregister-reason-custom'>
					<BizTextArea
						value={customReason}
						onChange={(e) => setCustomReason(e.target.value)}
						placeholder={otherReasonPlaceholder}
						rows={4}
						className='form-control'
					/>
					<div className='event-unregister-reason-actions'>
						<BizButton
							text={submitButtonText}
							onClick={() => submitAndClose(customReason.trim(), 'OTHER')}
							disabled={!canSubmitCustomReason}
							state={isSubmitting ? 'LOADING' : undefined}
							legacy={true}
						/>
					</div>
				</div>
			)}
		</div>
	);
};
